import { IS_PROD } from './common.constants';

export type NativeAppPlatform = 'ios' | 'android';

export interface LatestAppRelease {
	version: string;
	/** `CFBundleVersion` on iOS, `versionCode` on Android; null checks the version only. */
	build: string | null;
}

/**
 * Latest published builds of the WebToNative wrapper. A device below these is
 * locked behind the force-update sheet; equal or newer passes, so a TestFlight
 * or internal build is never locked out.
 *
 * Production gates on the marketing version alone. Every other environment
 * also gates on the build number — as a store listing reads it, 1.0 (13) — so
 * a rebuild of the same version can still be forced out during testing.
 *
 * Bump these together with each release.
 */
const PRODUCTION_RELEASES: Record<NativeAppPlatform, LatestAppRelease> = {
	ios: { version: '1.7', build: null },
	android: { version: '1.0', build: null },
};

const NON_PRODUCTION_RELEASES: Record<NativeAppPlatform, LatestAppRelease> = {
	ios: { version: '1.7', build: '16' },
	android: { version: '1.0', build: '5' },
};

export const LATEST_APP_RELEASE_BY_PLATFORM: Record<NativeAppPlatform, LatestAppRelease> = IS_PROD
	? PRODUCTION_RELEASES
	: NON_PRODUCTION_RELEASES;

export const IOS_VERSION = LATEST_APP_RELEASE_BY_PLATFORM.ios.version;
export const IOS_BUILD = LATEST_APP_RELEASE_BY_PLATFORM.ios.build;
export const ANDROID_VERSION = LATEST_APP_RELEASE_BY_PLATFORM.android.version;
export const ANDROID_BUILD = LATEST_APP_RELEASE_BY_PLATFORM.android.build;
